import ProjectController from '@/controllers/ProjectController'
import projectStore from '@/store/ProjectStore'
import { HpStep, ProjectStatus } from '@/helper/Types'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import FormController from '@/controllers/FormController'
import appStore from '@/store/AppStore'

export const downloadPageGuard = async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (projectStore.projectId !== to.params.projectId || appStore.currentStep !== HpStep.SUMMARY) {
    await ProjectController.loadProject(to.params.projectId as string)
      .then(() => FormController.loadFormData(HpStep.SUMMARY))
      .catch(() => next({ path: '/' }))
  }

  if (projectStore.status === ProjectStatus.COMPLETE) {
    next()
  } else {
    next({ path: '/project/' + projectStore.projectId })
  }
}
